import React, { useState } from 'react';
import { Box, Typography, Autocomplete, TextField, Tabs, Tab, Button, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { Download, ContentCopy } from '@mui/icons-material';
import SpinnerModal from './SpinnerModal';
import CheckCircle from '@mui/icons-material/CheckCircle'; // already imported


const RdbmsToNosql = () => {
  const [sourceSearch, setSourceSearch] = useState('');
  const [targetSearch, setTargetSearch] = useState('');
  const [sourceDb, setSourceDb] = useState('');
  const [targetDb, setTargetDb] = useState('');
  const [source_value, setSourceValue] = useState('');
  const [target_value, setTargetValue] = useState('');
  const [tabValue, setTabValue] = useState(0);
  const [progress, setProgress] = useState(0);
  const [ddlFile, setDdlFile] = useState(null);
  const [mappingFileName, setMappingFileName] = useState('');
  const [targetSchemaFileName, setTargetSchemaFileName] = useState('');

  const [submitApiResult, setSubmitApiResult] = useState(null);
  const [generateApiResult, setGenerateApiResult] = useState(null);
  const [insertionResult, setInsertionResult] = useState(null);

  const [showSpinnerModal, setShowSpinnerModal] = useState(false);
  const [showMigrationSpinnerModal, setShowMigrationSpinnerModal] = useState(false);
  const [showDataInsertionSpinnerModal, setShowDataInsertionSpinnerModal] = useState(false);
  const [showPythonScriptSpinnerModal, setShowPythonScriptSpinnerModal] = useState(false);

  const [connectionStatus, setConnectionStatus] = useState(null);

  const [sqlFileName, setSqlFileName] = useState('');
  const [dataInsertionMethod, setDataInsertionMethod] = useState('');

  const [hostname, setHostname] = useState('');
  const [port, setPort] = useState('');
  const [dbname, setDbname] = useState('');
  const [user, setUser] = useState('');
  const [password, setPassword] = useState('');
  const [target_url, setTarget_url] = useState('');

  const sourceOptions = ['Postgres'];
  const targetOptions = ['MongoDB'];

  const sourceDbOptions = ['Postgres',];
  const targetDbOptions = ['MongoDB',];

  const dropdownStyle = { width: '300px' };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue === 3) {
      setMigrationScriptCompleted(true);
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setDdlFile(file);
  };

   const getFileAccept = () => {
    if (sourceDb === 'Postgres') return '.sql,.ddl';
    return '';
  };


  const [spinnerType, setSpinnerType] = useState(null);

  const getSpinnerMessages = () => {
    switch (spinnerType) {
      case 'mapping':
        return {
          inProgress: 'Mapping is being generated...',
          success: 'Mapping generated Successfully!',
          open: showSpinnerModal,
          onClose: () => setShowSpinnerModal(false),
        };
      case 'migration':
        return {
          inProgress: 'Migration Script is being generated...',
          success: 'Migration Script generated successfully!',
          open: showMigrationSpinnerModal,
          onClose: () => setShowMigrationSpinnerModal(false),
        };
      case 'insertion':
        return {
          inProgress: 'Data Insertion is in progress...',
          success: 'Data Insertion done successfully!',
          open: showDataInsertionSpinnerModal,
          onClose: () => setShowDataInsertionSpinnerModal(false),
        };
      case 'python':
        return {
          inProgress: 'Python Script is being generated...',
          success: 'Python Script generated successfully!',
          open: showPythonScriptSpinnerModal,
          onClose: () => setShowPythonScriptSpinnerModal(false),
        };
      default:
        return {};
    }
  };

  const spinnerMessages = getSpinnerMessages();

  const handleSubmit = async () => {
    if (!sourceDb || !targetDb) {
      alert('Please select both source and target.');
      return;
    }

    if (!ddlFile) {
      alert('Please upload a DDL file before submitting.');
      return;
    }

    try {
      setSpinnerType('mapping');
      setShowSpinnerModal(true);
      setProgress(0);

      let interval=null;
      interval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= 90) {
            clearInterval(interval);
            return 90;
          }
          return prevProgress + 10;
        });
      }, 30000);

      const formData = new FormData();
      formData.append('file', ddlFile);

      const uploadResponse = await fetch('https://api.elevate.de.ltim.io/upload-to-s3/', {
        method: 'POST',
        body: formData,
      });

      if (!uploadResponse.ok) {
        const errorData = await uploadResponse.json();
        alert(`Error uploading DDL file: ${errorData.detail}`);
        clearInterval(interval);
        setShowSpinnerModal(false);
        return;
      }

      const uploadResult = await uploadResponse.json();
      console.log('DDL file uploaded successfully:', uploadResult);

      // Prepare payload for /sql_to_nosql/
      const payload = {
        source: sourceDb,
        target: targetDb,
        file_name: uploadResult.filename,
        // Only include target_file_name if available
        ...(targetSchemaFileName
          ? {
              target_file_name: targetSchemaFileName,
              is_target_file_available: true,
            }
          : {
              is_target_file_available: false,
            }),
      };

      const response = await fetch('https://api.elevate.de.ltim.io/sql_to_nosql/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      clearInterval(interval);

      if (!response.ok) {
        const errorData = await response.json();
        alert(`Error processing request: ${errorData.detail}`);
        setShowSpinnerModal(false);
        return;
      }

      const result = await response.json();
      console.log('SQL to NoSQL processing result:', result);

      setSubmitApiResult(result);
      setProgress(100);
      setTimeout(() => {
        setShowSpinnerModal(false);
        setTabValue(1);
      }, 3000);
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred while processing the request.');
      setShowSpinnerModal(false);
    }
  };

  const handleDownloadMapping = async () => {
    if (!submitApiResult || !submitApiResult.mapping_link || submitApiResult.mapping_link.length === 0) {
      alert('No mapping links available to download.');
      return;
    }

    submitApiResult.mapping_link.forEach((link) => {
      const anchor = document.createElement('a');
      anchor.href = link;
      anchor.target = '_self';
      anchor.download = '';
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    });

  };

  const handleDownloadOutputFile = () => {
    if (!generateApiResult || !generateApiResult.output_file_link || generateApiResult.output_file_link.length === 0) {
      alert('No mapping links available to download.');
      return;
    }

    generateApiResult.output_file_link.forEach((link) => {
      const anchor = document.createElement('a');
      anchor.href = link;
      anchor.target = '_self';
      anchor.download = '';
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    });
  };


  const handleFileUploadCsv = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      alert('Please select a file to upload.');
      return;
    }

    setMappingFileName(file.name);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const uploadResponse = await fetch('https://api.elevate.de.ltim.io/upload_to_nosql/', {
        method: 'POST',
        body: formData,
      });

      if (!uploadResponse.ok) {
        alert('Failed to upload the updated file.');
        return;
      }

    } catch (error) {
      console.error('Error uploading updated file:', error);
      alert('An error occurred while uploading the updated file.');
    }
  };

  const handleGenerateResult = async () => {
    if (!mappingFileName) {
      alert('Please upload a CSV file before generating the result.');
      return;
    }

    try {
      setSpinnerType('migration');
      setShowMigrationSpinnerModal(true);
      setProgress(0);

      let interval = null;
      interval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= 90) {
            clearInterval(interval);
            return 90;
          }
          return prevProgress + 10;
        });
      }, 15000);

      const payload = {
        file_name: mappingFileName,
        is_csv: true,
        is_ddl: false,
      };

      const response = await fetch('https://api.elevate.de.ltim.io/sql_to_nosql/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      clearInterval(interval);

      if (!response.ok) {
        const errorData = await response.json();
        alert(`Error generating result: ${errorData.detail}`);
        setShowMigrationSpinnerModal(false);
        return;
      }

      const result = await response.json();
      console.log('Result generated successfully:', result);

      setGenerateApiResult(result);
      setProgress(100);
      setTimeout(() => {
        setShowMigrationSpinnerModal(false);
        setTabValue(2);
      }, 3000);
    } catch (error) {
      console.error('Error generating result:', error);
      alert('An error occurred while generating the result.');
      setShowMigrationSpinnerModal(false);
    }
  };

  const handleValidateConnection = async () => {
    if (!source_value || !target_value || !hostname || !port || !dbname || !user || !password || !target_url) {
      alert('Please fill in all required fields.');
      return;
    }

    const payload = {
      source: source_value,
      target: target_value,
      source_config: {
        host: hostname,
        port: port,
        dbname: dbname,
        user: user,
        password: password,
      },
      target_url: target_url,
    };

    try {
      const response = await fetch('https://api.elevate.de.ltim.io/db_config/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        setConnectionStatus('failed');
        return;
      }

      const result = await response.json();
      if (result.is_valid === true) {
        setConnectionStatus('success');
      } else {
        setConnectionStatus('failed');
      }
    } catch (error) {
      setConnectionStatus('failed');
    }
  };

  const handleSqlFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setSqlFileName('');

    const formData = new FormData();
    formData.append('file', file);

    try {
      const uploadResponse = await fetch('https://api.elevate.de.ltim.io/upload_to_nosql_sql_file/', {
        method: 'POST',
        body: formData,
      });

      if (!uploadResponse.ok) {
        alert('Failed to upload the SQL file.');
        return;
      }

      setSqlFileName(file.name);
    } catch (error) {
      alert('An error occurred while uploading the SQL file.');
    }
  };
  const handleRadioChange = (event) => {
    setDataInsertionMethod(event.target.value);
  };

  const handleDataInsertion = async () => {
    if (!sqlFileName) {
      alert('Please upload the generated SQL file first.');
      return;
    }

    setSpinnerType(dataInsertionMethod === 'python' ? 'python' : 'insertion');
    if (dataInsertionMethod === 'python') {
      setShowPythonScriptSpinnerModal(true);
    } else {
      setShowDataInsertionSpinnerModal(true);
    }
    setProgress(0);

    let interval = null;
    interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 90) {
          clearInterval(interval);
          return 90;
        }
        return prevProgress + 10;
      });
    }, 10000);

    const payload = {
      file_name: sqlFileName,
      is_sql: true,
      is_csv: false,
      is_ddl: false,
      is_python_script: dataInsertionMethod === 'python'
    };

    try {
      const response = await fetch('https://api.elevate.de.ltim.io/sql_to_nosql/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      clearInterval(interval);

      if (!response.ok) {
        const errorData = await response.json();
        alert(`Error during data insertion: ${errorData.detail || 'Unknown error'}`);
        setShowDataInsertionSpinnerModal(false);
        setShowPythonScriptSpinnerModal(false);
        return;
      }

      const result = await response.json();
      setInsertionResult(result);
      setProgress(100);
      setTimeout(() => {
        setShowDataInsertionSpinnerModal(false);
        setShowPythonScriptSpinnerModal(false);
        setTabValue(4);
      }, 3000);
    } catch (error) {
      clearInterval(interval);
      alert('An error occurred during data insertion.');
      setShowDataInsertionSpinnerModal(false);
      setShowPythonScriptSpinnerModal(false);
    }
  };

  // Handler for target schema file upload
  const handleTargetSchemaUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      alert('Please select a file to upload.');
      return;
    }

    setTargetSchemaFileName(file.name);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const uploadResponse = await fetch('https://api.elevate.de.ltim.io/upload_to_nosql_target_file/', {
        method: 'POST',
        body: formData,
      });

      if (!uploadResponse.ok) {
        alert('Failed to upload the target schema file.');
        return;
      }
      // Optionally handle response here
    } catch (error) {
      console.error('Error uploading target schema file:', error);
      alert('An error occurred while uploading the target schema file.');
    }
  };

  const [migrationScriptCompleted, setMigrationScriptCompleted] = useState(false);

  return (
    <Box sx={{ width: '100%', marginTop: -7 }}>
 <Tabs
        value={tabValue}
        onChange={handleTabChange}
        sx={{
          pl: 0,
          '& .MuiTabs-flexContainer': { justifyContent: 'flex-start' },
          '& .MuiTab-root': {
            minWidth: 120,
            fontWeight: 'bold',
            textTransform: 'none',
            paddingRight: 0,
            pl: 0,
          },
        }}
        TabIndicatorProps={{ style: { display: 'none' } }}
      >
        {/* Input Tab */}
        <Tab
          label={
            <Box display="flex" alignItems="center">
              {/* 1 Input */}
              <Box display="flex" alignItems="center">
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  width={24}
                  height={24}
                  borderRadius="50%"
                  bgcolor={submitApiResult?.report ? "#4caf50" : (tabValue === 0 ? "#1976d2" : "white")}
                  border="1.5px solid"
                  borderColor={submitApiResult?.report ? "#4caf50" : (tabValue === 0 ? "#1976d2" : "black")}
                  mr={1}
                  transition="all 0.2s"
                >
                  {submitApiResult?.report ? (
                    <CheckCircle sx={{ color: "white", fontSize: 20 }} />
                  ) : (
                    <Typography variant="subtitle2" sx={{ color: tabValue === 0 ? "white" : "black", fontWeight: 600 }}>1</Typography>
                  )}
                </Box>
                <Typography
                  sx={{
                    fontWeight: tabValue === 0 ? 700 : 400,
                    color: tabValue === 0 ? "primary.main" : "black",
                    userSelect: "none",
                    transition: "all 0.2s"
                  }}
                >
                  Input
                </Typography>
              </Box>
              {/* Arrow */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  height: 4,
                  ml: 1,
                  mr: 1,
                  mb: 0.6,
                }}
              >
                <Typography sx={{ color: "#bdbdbd", fontWeight: 700, fontSize: 32, lineHeight: 1 }}>
                  &rarr;
                </Typography>
              </Box>
            </Box>
          }
          disableRipple
          style={{ minWidth: 0, paddingRight: 0, paddingLeft: 0 }}
        />

        {/* Mapping Tab */}
        <Tab
          label={
            <Box display="flex" alignItems="center">
              {/* 2 Mapping */}
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width={24}
                height={24}
                borderRadius="50%"
                bgcolor={generateApiResult?.report ? "#4caf50" : (tabValue === 1 ? "#1976d2" : "white")}
                border="1.5px solid"
                borderColor={generateApiResult?.report ? "#4caf50" : (tabValue === 1 ? "#1976d2" : "black")}
                mr={1}
                transition="all 0.2s"
              >
                {generateApiResult?.report ? (
                  <CheckCircle sx={{ color: "white", fontSize: 20 }} />
                ) : (
                  <Typography variant="subtitle2" sx={{ color: tabValue === 1 ? "white" : "black", fontWeight: 600 }}>2</Typography>
                )}
              </Box>
              <Typography
                sx={{
                  fontWeight: tabValue === 1 ? 700 : 400,
                  color: tabValue === 1 ? "primary.main" : "black",
                  userSelect: "none",
                  transition: "all 0.2s"
                }}
              >
                Mapping
              </Typography>
              {/* Arrow */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  height: 4,
                  ml: 1,
                  mr: 1,
                  mb: 0.6,
                }}
              >
                <Typography sx={{ color: "#bdbdbd", fontWeight: 700, fontSize: 32, lineHeight: 1 }}>
                  &rarr;
                </Typography>
              </Box>
            </Box>
          }
          disableRipple
          style={{ minWidth: 0, paddingLeft: 0, paddingRight: 0 }}
        />

        <Tab
          label={
            <Box display="flex" alignItems="center">
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width={24}
                height={24}
                borderRadius="50%"
                bgcolor={migrationScriptCompleted ? "#4caf50" : (tabValue === 2 ? "#1976d2" : "white")}
                border="1.5px solid"
                borderColor={migrationScriptCompleted ? "#4caf50" : (tabValue === 2 ? "#1976d2" : "black")}
                mr={1}
                transition="all 0.2s"
              >
                {migrationScriptCompleted ? (
                  <CheckCircle sx={{ color: "white", fontSize: 20 }} />
                ) : (
                  <Typography variant="subtitle2" sx={{ color: tabValue === 2 ? "white" : "black", fontWeight: 600 }}>3</Typography>
                )}
              </Box>
              <Typography
                sx={{
                  fontWeight: tabValue === 2 ? 700 : 400,
                  color: tabValue === 2 ? "primary.main" : "black",
                  userSelect: "none",
                  transition: "all 0.2s"
                }}
              >
                Migration Script
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  height: 4,
                  ml: 1,
                  mr: 1,
                  mb: 0.6,
                }}
              >
                <Typography sx={{ color: "#bdbdbd", fontWeight: 700, fontSize: 32, lineHeight: 1 }}>
                  &rarr;
                </Typography>
              </Box>
            </Box>
          }
          disableRipple
          style={{ minWidth: 0, paddingLeft: 0, paddingRight: 0 }}
        />

       

        {/* Data Insertion Tab */}
        <Tab
          label={
            <Box display="flex" alignItems="center">
              {/* 5 Data Insertion */}
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width={24}
                height={24}
                borderRadius="50%"
                bgcolor={insertionResult?.report ? "#4caf50" : tabValue === 3 ? "#1976d2" : "white"}
                border="1.5px solid"
                borderColor={insertionResult?.report ? "#4caf50" : tabValue === 3 ? "#1976d2" : "black"}
                mr={1}
                transition="all 0.2s"
              >
                {insertionResult?.report ? (
                  <CheckCircle sx={{ color: "white", fontSize: 20 }} />
                ) : (
                  <Typography variant="subtitle2" sx={{ color: tabValue === 3 ? "white" : "black", fontWeight: 600 }}>4</Typography>
                )}
                </Box>
              <Typography
                sx={{
                  fontWeight: tabValue === 3 ? 700 : 400,
                  color: tabValue === 3 ? "primary.main" : "black",
                  userSelect: "none",
                  transition: "all 0.2s"
                }}
              >
                Data Insertion
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  height: 4,
                  ml: 1,
                  mr: 1,
                  mb: 0.6,
                }}
              >
                <Typography sx={{ color: "#bdbdbd", fontWeight: 700, fontSize: 32, lineHeight: 1 }}>
                  &rarr;
                </Typography>
              </Box>
            </Box>
          }
          disableRipple
          style={{ minWidth: 0, paddingLeft: 0, paddingRight: 0 }}
        />

        {/* Result Tab */}
        <Tab
          label={
            <Box display="flex" alignItems="center">
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width={24}
                height={24}
                borderRadius="50%"
                bgcolor={tabValue === 4 ? "#1976d2" : "white"}
                border="1.5px solid"
                borderColor={tabValue === 4 ? "#1976d2" : "black"}
                mr={1}
                transition="all 0.2s"
              >
                <Typography variant="subtitle2" sx={{ color: tabValue === 4 ? "white" : "black", fontWeight: 600 }}>5</Typography>
              </Box>
              <Typography
                sx={{
                  fontWeight: tabValue === 4 ? 700 : 400,
                  color: tabValue === 4 ? "primary.main" : "black",
                  userSelect: "none",
                  transition: "all 0.2s"
                }}
              >
                Result
              </Typography>
            </Box>
          }
          disableRipple
          style={{ minWidth: 0, paddingLeft: 0, paddingRight: 0 }}
        />
      </Tabs>


      {tabValue === 0 && (
        <Box sx={{ marginTop: 2 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              width: '100%',
              gap: 2,
            }}
          >
            <Box sx={{ maxWidth: '300px' }}>
              <Typography variant="subtitle1" id="source-label" sx={{ fontWeight: 'bold' }}>
                Source<span style={{ color: 'red' }}>*</span>
              </Typography>
              <Autocomplete
                options={sourceOptions}
                value={sourceDb || ''}
                onChange={(event, newValue) => setSourceDb(newValue || '')}
                inputValue={sourceSearch}
                onInputChange={(event, newInputValue) => setSourceSearch(newInputValue)}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Source" variant="outlined" size="small" />
                )}
                sx={dropdownStyle}
              />

              <Typography variant="subtitle1" sx={{ marginTop: 2, fontWeight: 'bold', marginBottom: 1 }}>
                Please upload DDL file<span style={{ color: 'red' }}>*</span>
              </Typography>
              <Button
                variant="contained"
                color="primary"
                component="label"
                sx={{
                  backgroundColor: 'white',
                  color: 'black',
                  border: '1px solid black',
                  boxShadow: 'none',
                  height: '40px',
                }}
              >
                Upload File
                <input
                  type="file"
                  hidden
                  onChange={handleFileUpload}
                  accept={getFileAccept()}
                />
              </Button>

              {ddlFile && (
                <Typography variant="body2" sx={{ marginTop: 1, color: 'green', fontWeight: 'bold' }}>
                  Uploaded: {ddlFile.name}
                </Typography>
              )}

              {ddlFile && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  sx={{
                    marginTop: 2,
                    backgroundColor: 'white',
                    color: 'black',
                    border: '1px solid black',
                    boxShadow: 'none',
                    height: '40px',
                  }}
                >
                  Generate Mapping
                </Button>
              )}
            </Box>

            <Box sx={{ maxWidth: '300px', marginRight: '150px' }}>
              <Typography variant="subtitle1" id="target-label" sx={{ fontWeight: 'bold' }}>
                Target<span style={{ color: 'red' }}>*</span>
              </Typography>
              <Autocomplete
                options={targetOptions}
                value={targetDb || ''}
                onChange={(event, newValue) => setTargetDb(newValue || '')}
                inputValue={targetSearch}
                onInputChange={(event, newInputValue) => setTargetSearch(newInputValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select Target"
                    variant="outlined"
                    size="small"
                  />
                )}
                sx={dropdownStyle}
              />
              {/* New: Upload Target Schema button below Target dropdown */}
              <Box sx={{ marginTop: 2 }}>
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 'bold',
                    color: '#333',
                    marginBottom: 1,
                  }}
                >
                  Please upload target schema
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  component="label"
                  sx={{
                    backgroundColor: 'white',
                    color: 'black',
                    border: '1px solid black',
                    boxShadow: 'none',
                  }}
                >
                  Upload File
                  <input
                    type="file"
                    hidden
                    onChange={handleTargetSchemaUpload}
                  />
                </Button>
                {targetSchemaFileName && (
                  <Typography variant="body2" sx={{ marginTop: 1, color: 'green', fontWeight: 'bold' }}>
                    Uploaded: {targetSchemaFileName}
                  </Typography>
                )}
              </Box>
              {/* End new section */}
            </Box>
          </Box>
        </Box>
      )}

      {tabValue === 1 && (
        <Box sx={{ marginTop: 2 }}>
          <Box
            sx={{
              marginTop: 4,
              padding: '16px',
              backgroundColor: '#f9f9f9',
              borderRadius: '8px',
              border: '1px solid #ccc',
              marginBottom: 2,
            }}
          >
            <Typography variant="h6" sx={{ marginBottom: 2 }}>
              Output
            </Typography>
            {submitApiResult?.report ? (
              <Typography
                variant="body1"
                sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}
              >
                {String(submitApiResult.report)}
              </Typography>
            ) : (
              <Typography variant="body2">No result available</Typography>
            )}
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight: 'bold',
                color: '#333',
                marginBottom: 1,
              }}
            >
              Please Download and Review the Mapping CSV
            </Typography>


            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
              }}
            >
              {submitApiResult?.mapping_link?.length > 0 && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleDownloadMapping}
                  sx={{
                    backgroundColor: 'white',
                    color: 'black',
                    border: '1px solid black',
                    boxShadow: 'none',
                  }}
                  startIcon={<Download />}
                >
                  Download Mapping
                </Button>
              )}

              <Box sx={{ marginTop: 2 }}>
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 'bold',
                    color: '#333',
                    marginBottom: 1,
                  }}
                >
                  Please upload the reviewed mapping CSV
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  component="label"
                  sx={{
                    backgroundColor: 'white',
                    color: 'black',
                    border: '1px solid black',
                    boxShadow: 'none',
                  }}
                >
                  Upload File
                  <input
                    type="file"
                    hidden
                    onChange={handleFileUploadCsv}
                  />
                </Button>
                {mappingFileName && (
                  <><Typography
                    variant="body2"
                    sx={{ marginTop: 1, color: 'green', fontWeight: 'bold' }}
                  >
                    Uploaded File: {mappingFileName}
                  </Typography><Button
                    variant="contained"
                    color="primary"
                    onClick={handleGenerateResult}
                    sx={{
                      marginTop: 2,
                      backgroundColor: 'white',
                      color: 'black',
                      border: '1px solid black',
                      boxShadow: 'none',
                      height: '40px',
                    }}
                  >
                      Generate Migration Script
                    </Button></>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {tabValue === 2 && (
        <Box sx={{ marginTop: 2 }}>
          <Box
            sx={{
              marginTop: 4,
              padding: '16px',
              backgroundColor: '#f9f9f9',
              borderRadius: '8px',
              border: '1px solid #ccc',
              marginBottom: 2,
            }}
          >
            <Typography variant="h6" sx={{ marginBottom: 2 }}>
              Migration Script
            </Typography>
            {generateApiResult?.report ? (
              <Typography
                variant="body1"
                sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}
              >
                {String(generateApiResult.report)}
              </Typography>
            ) : (
              <Typography variant="body2">No result available. Please generate the migration script first.</Typography>
            )}
          </Box>

          <Box sx={{ marginTop: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleDownloadOutputFile}
              sx={{
                backgroundColor: 'white',
                color: 'black',
                border: '1px solid black',
                boxShadow: 'none',
              }}
              startIcon={<Download />}
            >
              Download Migration Script
            </Button>
          </Box>

          <Typography
            variant="body1"
            sx={{
              marginTop: 2,
              fontWeight: 'bold',
              color: '#333',
            }}
          >
            Please proceed to the next tab for data insertion script.
          </Typography>
        </Box>
      )}

      {tabValue === 3 && (
        <Box sx={{ marginTop: 2 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              width: '100%',
              gap: 2,
            }}
          >
            <Box sx={{ maxWidth: '300px' }}>
              <Typography variant="subtitle1" id="source-connection-label" sx={{ fontWeight: 'bold' }}>
                Source DB Connection Details<span style={{ color: 'red' }}>*</span>
              </Typography>
              <Autocomplete
                options={sourceDbOptions}
                value={source_value || ''}
                onChange={(event, newValue) => setSourceValue(newValue || '')}
                inputValue={sourceSearch}
                onInputChange={(event, newInputValue) => setSourceSearch(newInputValue)}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Source DB" variant="outlined" size="small" />
                )}
                sx={dropdownStyle}
              />

              {source_value && (
                <Box sx={{ marginTop: 3 }}>
                  <TextField
                    label="Hostname"
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={{ marginBottom: 2 }}
                    value={hostname}
                    onChange={(e) => setHostname(e.target.value)}
                  />

                  <TextField
                  label="Port"
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={{ marginBottom: 2 }}
                    value={port}
                    onChange={(e) => setPort(e.target.value)}
                  />

                  <TextField
                  label="dbname"
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={{ marginBottom: 2 }}
                    value={dbname}
                    onChange={(e) => setDbname(e.target.value)}
                  />

                  <TextField
                  label="User"
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={{ marginBottom: 2 }}
                    value={user}
                    onChange={(e) => setUser(e.target.value)}
                  />

                  <TextField
                  label="Password"
                    variant="outlined"
                    size="small"
                    type="password"
                    fullWidth
                    sx={{ marginBottom: 2 }}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </Box>
              )}
               {hostname && port && dbname && user && password && target_url && (
                <>
                <Box sx={{ marginTop: 2, display: 'flex', justifyContent: 'flex-start' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleValidateConnection}
                    sx={{
                      backgroundColor: 'white',
                      color: 'black',
                      border: '1px solid black',
                      boxShadow: 'none',
                    }}
                  >
                    Validate Connection
                  </Button>
                </Box>
                {connectionStatus === 'success' && (
                  <Typography sx={{ color: 'green', marginTop: 1, fontWeight: 'bold',whiteSpace: 'nowrap' }}>
                    Source and Target connection established successfully
                  </Typography>
                )}
                {connectionStatus === 'failed' && (
                  <Typography sx={{ color: 'red', marginTop: 1, fontWeight: 'bold',whiteSpace: 'nowrap' }}>
                    Source and Target connection failed, please review the inputs
                  </Typography>
                )}

                {connectionStatus === 'success' && (
                <Box sx={{ marginTop: 2 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold', marginBottom: 1 }}>
                    Please upload generated sql script
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    component="label"
                    sx={{
                      backgroundColor: 'white',
                      color: 'black',
                      border: '1px solid black',
                      boxShadow: 'none',
                    }}
                  >
                    Upload Generated SQL
                    <input
                      type="file"
                      hidden
                      onChange={handleSqlFileUpload}
                    />
                  </Button>
                  {sqlFileName && (
                    <>
                      <Typography
                        variant="body2"
                        sx={{ marginTop: 1, color: 'green', fontWeight: 'bold' }}
                      >
                        Uploaded: {sqlFileName}
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        sx={{ marginTop: 2, fontWeight: 'bold' ,whiteSpace: 'nowrap'}}
                      >
                        Please select the below option for creating data insertion
                      </Typography>
                      <RadioGroup
                        row
                        aria-label="data-insertion-method"
                        name="data-insertion-method"
                        sx={{ marginTop: 1 }}
                        value={dataInsertionMethod}
                        onChange={handleRadioChange}
                      >
                        <FormControlLabel
                          value="python"
                          control={<Radio />}
                          label="Python script"
                        />
                        <FormControlLabel
                          value="direct"
                          control={<Radio />}
                          label="Direct Database Insertion"
                        />
                      </RadioGroup>
                      {dataInsertionMethod && (
                        <Button
                          variant="contained"
                          color="primary"
                          sx={{
                            marginTop: 2,
                            backgroundColor: 'white',
                            color: 'black',
                            border: '1px solid black',
                            boxShadow: 'none',
                          }}
                          onClick={handleDataInsertion}
                        >
                          {dataInsertionMethod === 'python' ? 'Submit' : 'Data Insertion'}
                        </Button>
                      )}
                    </>
                  )}
                </Box>
                )}
                </>
              )}
            </Box>

            <Box sx={{ maxWidth: '300px', marginRight: '150px' }}>
              <Typography variant="subtitle1" id="target-connection-label" sx={{ fontWeight: 'bold' }}>
                Target DB Connection Details<span style={{ color: 'red' }}>*</span>
              </Typography>
              <Autocomplete
                options={targetDbOptions}
                value={target_value || ''}
                onChange={(event, newValue) => setTargetValue(newValue || '')}
                inputValue={targetSearch}
                onInputChange={(event, newInputValue) => setTargetSearch(newInputValue)}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Target DB" variant="outlined" size="small" />
                )}
                sx={dropdownStyle}
              />
              {target_value && (
                <Box sx={{ marginTop: 3 }}>
                  <TextField
                  label="Target URL"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={target_url}
                    onChange={(e) => setTarget_url(e.target.value)}
                  />
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      )}

      <SpinnerModal
        open={spinnerMessages.open}
        progress={progress}
        inProgressMessage={spinnerMessages.inProgress}
        successMessage={spinnerMessages.success}
        onClose={spinnerMessages.onClose}
      />

      {tabValue === 4 && (
        <Box sx={{ marginTop: 2 }}>
          <Box
            sx={{
              marginTop: 4,
              padding: '16px',
              backgroundColor: '#f9f9f9',
              borderRadius: '8px',
              border: '1px solid #ccc',
              marginBottom: 2,
            }}
          >
            <Typography variant="h6" sx={{ marginBottom: 2 }}>
              {dataInsertionMethod === 'python'
                ? 'Python Script'
                : 'Data Insertion'}
            </Typography>
            {insertionResult?.report ? (
              <Typography
                variant="body1"
                sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', wordWrap: 'break-word' }}
              >
                {String(insertionResult.report)}
              </Typography>
            ) : (
              <Typography variant="body2">No result available</Typography>
            )}
          </Box>
          {dataInsertionMethod === 'python' && (
            <Button
              variant="contained"
              color="primary"
              startIcon={<ContentCopy />}
              onClick={() => {
                if (insertionResult?.report) {
                  navigator.clipboard.writeText(String(insertionResult.report));
                }
              }}
              sx={{
                backgroundColor: 'white',
                color: 'black',
                border: '1px solid black',
                boxShadow: 'none',
                marginTop: 1,
              }}
              disabled={!insertionResult?.report}
            >
              Copy Code
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};

export default RdbmsToNosql;